import Content from '@nexys/components/Content/Content'
import Gap from '@nexys/components/Gap'

import useGetAllArticle from 'data/useGetAllArticle'

import Announcement from './partials/Announcement'
import Gallery from './partials/Galery'
import Hero from './partials/Hero'
import MediaPromotion from './partials/MediaPromotion'
import OurActivity from './partials/OurActivity'

const styleContent = {
  paddingTop: 20,
  paddingBottom: 50,
}

export interface ExampleDir {
  directory: string
  totalFiles: number
}

interface HomeProps {
  exampleDirs: ExampleDir[]
}

function Home(_: HomeProps) {
  // const { xs } = useBreakpoint()
  const { data: articleData } = useGetAllArticle(1, 99)

  return (
    <div>
      <Content style={{ ...styleContent }}>
        <Gap height="50px" />
        <Hero articleData={articleData} />
        <OurActivity articleData={articleData} />
        {/* <HightlightPost articleData={articleData} /> */}
        <Gap height={'50px'} />
        <Announcement />
        <Gap height={'50px'} />
        <MediaPromotion />
        {/* <Gap height={'50px'} /> */}
        {/* <Information /> */}
        <Gallery />
      </Content>
    </div>
  )
}

export default Home
